<template>
  <label
    class="select-hour"
    :class="{
      'select-hour--reported': reported,
      'select-hour--reported-elsewhere': reportedElsewhere,
      'select-hour--reported-nonplanned': reportedNonplanned,
    }"
    :for="`select-${this._uid}`"
  >
    <span class="miv">R</span>
    <select
      :id="`select-${this._uid}`"
      :value="value"
      :disabled="disabled"
      @change="$emit('input', $event.target.value), $emit('change')"
    >
      <option v-if="!value" :value="null">-</option>
      <option v-for="h in filteredHours" :key="`h-${h}`" :value="h">
        {{ h }}
      </option>
    </select>
  </label>
</template>

<script>
import hours from "../mixins/hours.js";
export default {
  mixins: [hours],
  props: [
    "value",
    "start",
    "disabled",
    "end",
    "reported",
    "reportedElsewhere",
    "reportedNonplanned",
    "min",
    "max",
  ],
  computed: {
    // hours between min and max (the current value is always kept)
    allowedHours() {
      if (!this.min && !this.max) {
        return this.hours;
      }

      const min = this.min ? this.hours.indexOf(this.min) : 0;
      const max = this.max ? this.hours.indexOf(this.max) : this.hours.length;

      return this.hours.filter((o, i) => {
        return (i >= min && i <= max) || o === this.value;
      });
    },
    filteredHours() {
      // TODO: refactor this, no time now
      // tbh the whole app needs to be refactored, but that prob won't happen
      if (this.start || this.end) {
        const index = this.hours.indexOf(this.start || this.end);

        if (this.start) {
          return this.allowedHours.filter((o) => {
            return this.hours.indexOf(o) > index;
          });
        } else {
          return this.allowedHours.filter((o) => {
            return this.hours.indexOf(o) < index;
          });
        }
      }

      return this.allowedHours;
    },
  },
};
</script>

<style scoped>
.select-hour {
  align-items: center;
  background-color: #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  height: 20px;
  justify-content: center;
  margin: 1px 2px;
  padding: 0 10px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  white-space: nowrap;
}
.select-hour:hover {
  background-color: #dbdada;
}
.select-hour select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border: 0;
  color: #737373;
  cursor: pointer;
}
.select-hour .miv {
  color: #3b86ff;
  margin-right: 10px;
}
.select-hour--reported {
  background-color: #a9d2a7;
}
.select-hour--reported select {
  color: #1d1d1d;
}
.select-hour--reported .miv {
  color: #005a9e;
}
.select-hour--reported-nonplanned {
  background-color: #9fd3e3;
}
.select-hour--reported-nonplanned select {
  color: #1d1d1d;
}
.select-hour--reported-nonplanned .miv {
  color: #005a9e;
}
.select-hour--reported-elsewhere {
  background-color: #ecc98c;
}
.select-hour--reported-elsewhere select {
  color: #7a5100;
}
.select-hour--reported-elsewhere .miv {
  color: #7a5100;
}
</style>